import React from "react";
import { Button, ButtonProps } from "components/Buttons";

type DangerButtonProps = Omit<ButtonProps, "color">;

export const DangerButton = (props: DangerButtonProps) => <Button {...props} color="danger" />;
